import React from 'react';
import './ImageModal.css';

const ImageModal = ({ imageUrl, alt, onClose }) => {
  // Empêche la propagation du clic à l'intérieur du modal
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="image-modal-overlay" onClick={onClose}>
      <div className="image-modal-content" onClick={handleContentClick}>
        <span className="image-modal-close" onClick={onClose}>&times;</span>
        <img 
          src={imageUrl} 
          alt={alt || "Image en plein écran"} 
          className="image-modal-img"
        />
      </div>
    </div>
  );
};

export default ImageModal;
